// src/components/ResetPassword.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './Login.css'; // We hergebruiken de Login styling

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    // Check of token en email aanwezig zijn
    if (!token || !email) {
      setTokenValid(false);
      setError('Ongeldige reset link. Vraag een nieuwe wachtwoord reset aan.');
    }
  }, [token, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    // Validatie
    if (password.length < 6) {
      setError('Wachtwoord moet minimaal 6 karakters zijn.');
      setIsLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError('Wachtwoorden komen niet overeen.');
      setIsLoading(false);
      return;
    }

    try {
      console.log('🔐 Resetting password for:', email);

      // Call Firebase Function
      const functionUrl = 'https://us-central1-piramide-scan.cloudfunctions.net/resetPasswordWithToken';
      
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: token,
          email: email,
          newPassword: password
        })
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Failed to reset password');
      }

      console.log('✅ Password reset successful');
      setSuccess(true);

      // Redirect naar login na 3 seconden
      setTimeout(() => {
        navigate('/login', { 
          state: { 
            message: 'Wachtwoord succesvol gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.' 
          }
        });
      }, 3000);

    } catch (error) {
      console.error('❌ Password reset error:', error);
      
      let errorMessage = 'Er is een fout opgetreden bij het resetten van je wachtwoord.';
      
      if (error.message.includes('expired')) {
        errorMessage = 'Deze reset link is verlopen. Vraag een nieuwe wachtwoord reset aan.';
      } else if (error.message.includes('used')) {
        errorMessage = 'Deze reset link is al gebruikt. Vraag een nieuwe wachtwoord reset aan als je je wachtwoord nog steeds wilt wijzigen.';
      } else if (error.message.includes('Invalid')) {
        errorMessage = 'Ongeldige reset link. Vraag een nieuwe wachtwoord reset aan.';
      }
      
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  if (!tokenValid) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Ongeldige Link</h1>
          </div>
          <div className="login-content">
            <div className="error-message">
              {error}
            </div>
            <Link to="/login" className="btn-primary" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Terug naar Inloggen
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Wachtwoord Gewijzigd!</h1>
          </div>
          <div className="login-content">
            <div className="success-message">
              Je wachtwoord is succesvol gewijzigd. Je wordt doorgestuurd naar de inlogpagina...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Nieuw Wachtwoord</h1>
          <p>Voer je nieuwe wachtwoord in voor {email}</p>
        </div>

        <div className="login-content">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">
                Nieuw Wachtwoord
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
                placeholder="Minimaal 6 karakters"
                minLength="6"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Bevestig Wachtwoord
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="form-input"
                placeholder="Herhaal je wachtwoord"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary"
            >
              {isLoading ? (
                <span className="loading-content">
                  <div className="loading-spinner"></div>
                  Wachtwoord wijzigen...
                </span>
              ) : (
                'Wachtwoord Wijzigen'
              )}
            </button>
          </form>
        </div>

        <div className="login-footer">
          <Link to="/login" className="footer-link">
            ← Terug naar inloggen
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;